import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { ajaxservice } from '../../../../../app/services/ajaxservice';
import { RaisecomplaintComponent } from '../raisecomplaint/raisecomplaint.component';

@Component({
  selector: 'kt-newenduser',
  templateUrl: './newenduser.component.html',
  styleUrls: ['./newenduser.component.scss'],
  providers: [RaisecomplaintComponent]
})
export class NewenduserComponent implements OnInit {

  Facility: FormGroup;

  states: any;
  districts: any;
  product_details: any;
  showTable: Boolean = false;
  customer_details: any;
  product_list: any;
  site_details: any;
  enduser_details: any;
  billingaddress_details: any;
  modal_properties: any;
  today: number = Date.now();
  fluid: boolean;
  dtOptions: DataTables.Settings = {};

  constructor(
    private chRef: ChangeDetectorRef,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public ajax: ajaxservice
  ) {
    this.Facility = new FormGroup({
      'state_id': new FormControl(null),
      'district_id': new FormControl(null),
      'barcode': new FormControl(''),
    })
   }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
				"zeroRecords": 'No Data Available'
			}
    }
    console.log("sgjdjgdjahsd 44")
    this.onChangeCountry();
  }

  onChangeCountry() {
    var country = +101; // country: number
    var url = 'get_state/?'; // api url for getting the details with using post params
    var id = "country_id";
    this.ajax.getdataparam(url, id, country).subscribe((result) => {
      if (result.response.response_code == "200" || result.response.response_code == "400") {
        this.states = result.response.data;
        this.chRef.detectChanges();
      } else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');
      } else {
        this.toastr.error("Something went wrong", 'Error');
      }
    }, (err) => {
      console.log(err); //prints if it encounters an error
    });
  }

  onChangeState(state_id) {
    var state = +state_id; // state: number
    var id = "state_id";
    var url = 'get_city/?'; // api url for getting the cities
    this.ajax.getdataparam(url, id, state).subscribe((result) => {
      if (result.response.response_code == "200") {
        this.districts = result.response.data; //storing the api response in the array
      }
      else if (result.response.response_code == "400") {
        this.districts = [];
      }
      else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error')
      }
      else {
        this.toastr.error("Something went wrong", 'Error')
      }
    }, (err) => {
      console.log(err); //prints if it encounters an error
    });
  }

  searchBarCode() {
    if (this.Facility.value.barcode != '' && this.Facility.value.barcode != null) {
      this.showTable = false;
      var url = 'get_equipment_details/';
      var data = {
        'barcode': this.Facility.value.barcode
      }
      this.ajax.postdata(url, data).subscribe((result) => {
        if (result.response.response_code == 200 || result.response.response_code == 400) {
          this.product_details = result.response.data;
          this.showTable = true;
          this.chRef.detectChanges();
        } else if(result.response.response_code == 500) {
          this.toastr.error(result.response.message, 'Error')
        } else {
          this.toastr.error("Something went wrong", 'Error')
        }
      }, (err) => {
        console.log(err); //prints if it encounters an error
      });
    }
  }

  raisecomplaint() {
    this.modal_properties = {
      customer_code: this.product_details[0].customer_code,
      customer_contract_id: this.product_details[0].contract_id,
      product_id: this.product_details[0].product.product_id,
      product_sub_id: this.product_details[0].sub_product.product_sub_id,
      model_no: this.product_details[0].model.model_name,
      part_number: this.product_details[0].part_number,
      serial_no: this.product_details[0].serial_no,
      end_userdetails_id: this.product_details[0].end_userdetails_id,
      billing_address_id: this.product_details[0].billing_address_id,
      contract_type_id: this.product_details[0].contract.amc_id
    }
    const modalRef: NgbModalRef = this.modalService.open(RaisecomplaintComponent, {
      size: 'lg', //specifies the size of the dialog box
      windowClass: "center-modalsm",
      backdrop: 'static',              //popup outside click by Sowndarya
      keyboard: false
    });
    modalRef.componentInstance.modal_properties = this.modal_properties;
  }

}
